// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3xkdD","rightAdornment":"Header_rightAdornment__16CHR"};